module.exports = "i {\n  color: #0079c2;\n  margin-right: 10px; }\n\n.italic {\n  font-style: italic; }\n\n.map-column {\n  height: 100%;\n  padding: 0;\n  margin-top: 20px; }\n\n.map-column iframe {\n    width: 100%;\n    height: 100%; }\n\n@media (-webkit-min-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3 / 2), (min--moz-device-pixel-ratio: 1.5), (min-device-pixel-ratio: 1.5), (max-width: 900px) {\n  .map-column {\n    height: auto !important;\n    min-height: 500px; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/contact/contact.component.scss
// module id = ./src/app/pages/contact/contact.component.scss
// module chunks = main